import styled from 'vue3-styled-components';

export const PreviewModalWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
`;

export const ModalOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
`;

export const ModalContent = styled.div`
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    max-width: 90vw;
    max-height: 90vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 24px;
    border-bottom: 1px solid #e5e7eb;
    background-color: #f9fafb;
`;

export const ModalTitle = styled.h2`
    font-size: 1.25rem;
    font-weight: 600;
    color: #111827;
    margin: 0;
    word-break: break-all;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 40px;
    color: #6b7280;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: all 0.2s;

    &:hover {
        background-color: #f3f4f6;
        color: #374151;
    }
`;

export const ModalBody = styled.div`
    flex: 1;
    padding: 24px;
    overflow: auto;
    min-height: 400px;
`;

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
`;

export const LoadingSpinner = styled.div`
    color: #6b7280;
    font-size: 1.1rem;
`;

export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 300px;
    text-align: center;
`;

export const ErrorIcon = styled.div`
    font-size: 3rem;
    margin-bottom: 16px;
`;

export const ErrorMessage = styled.div`
    color: #dc2626;
    font-size: 1.1rem;
    margin-bottom: 16px;
`;

export const RetryButton = styled.button`
    background-color: #3b82f6;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #2563eb;
    }
`;

export const PreviewContainer = styled.div`
    width: 100%;
    min-height: 400px;
`;

export const ImagePreview = styled.img`
    max-width: 100%;
    max-height: 70vh;
    object-fit: contain;
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    display: block;
    margin: 0 auto;
`;

export const PDFPreview = styled.div`
    width: 100%;
    height: 600px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);

    embed {
        border-radius: 8px;
    }
`;

export const TextPreview = styled.div`
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 16px;
    max-height: 500px;
    overflow: auto;

    pre {
        margin: 0;
        font-family: 'Courier New', monospace;
        font-size: 0.9rem;
        line-height: 1.5;
        color: #334155;
        white-space: pre-wrap;
        word-break: break-word;
    }
`;

export const UnsupportedPreview = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;
    text-align: center;
`;

export const UnsupportedIcon = styled.div`
    font-size: 4rem;
    margin-bottom: 16px;
    opacity: 0.7;
`;

export const UnsupportedMessage = styled.div`
    color: #6b7280;
    font-size: 1.1rem;
    margin-bottom: 24px;
`;

export const FileInfo = styled.div`
    background-color: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 16px;
    text-align: left;
    max-width: 400px;
`;

export const InfoItem = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const InfoLabel = styled.span`
    color: #6b7280;
    font-weight: 500;
    margin-right: 12px;
`;

export const InfoValue = styled.span`
    color: #111827;
    font-weight: 400;
`;

export const ModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid #e5e7eb;
    background-color: #f9fafb;
`;

export const DownloadButton = styled.button`
    background-color: #10b981;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    gap: 6px;

    &:hover {
        background-color: #059669;
    }
`;

export const CloseModalButton = styled.button`
    background-color: #6b7280;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #4b5563;
    }
`;